__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "spa_boclient";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("axios", "1.20.0", () => (__webpack_require__.e(69).then(() => (() => (__webpack_require__("daca1f84340307c1e74e"))))));
			register("lodash", "4.17.23", () => (__webpack_require__.e(972).then(() => (() => (__webpack_require__("b2dfe96cf7ba356a183c"))))));
			register("vue-i18n", "8.21.0", () => (__webpack_require__.e(765).then(() => (() => (__webpack_require__("6b9d1eaeb9944e642e6e"))))));
			register("vue-router", "3.1.3", () => (__webpack_require__.e(173).then(() => (() => (__webpack_require__("c3b0708e8710951e3c0b"))))));
			register("vue", "2.7.16", () => (__webpack_require__.e(893).then(() => (() => (__webpack_require__("5d66ea4228cad10957dc"))))));
			register("vuetify", "2.5.10", () => (Promise.all([__webpack_require__.e(600), __webpack_require__.e(442)]).then(() => (() => (__webpack_require__("6c2a5fec4f1ea66fee7d"))))));
			register("vuex", "3.1.1", () => (__webpack_require__.e(353).then(() => (() => (__webpack_require__("999c55cff43a633f7a5f"))))));
			initExternal("48f72acb077a53bc812d");
			initExternal("69acf2f284296c992bec");
			initExternal("3ad34f6858e40f8882cd");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};